import type { Theme } from '@mui/material';

const iconButton: Theme['components'] = {
  MuiIconButton: {
    defaultProps: {
      size: 'medium',
    },
    styleOverrides: {
      root: {
        '& .MuiSvgIcon-root, & i': {
          fontSize: 'inherit',
        },
        borderRadius: 'var(--mui-shape-customBorderRadius-sm)',
      },
      sizeSmall: {
        padding: '4px',
        width: '24px',
        height: '24px',
        minWidth: '24px',
        minHeight: '24px',
        fontSize: '16px',
      },
      sizeMedium: {
        padding: '4px',
        width: '32px',
        height: '32px',
        minWidth: '32px',
        minHeight: '32px',
        fontSize: '20px',
      },
    },
    variants: [
      {
        props: { color: 'default' },
        style: {
          '&:not(.Mui-disabled):hover, &:not(.Mui-disabled):active': {
            backgroundColor: 'var(--mui-palette-primary-dark)',
          },
          '&.Mui-disabled': {
            color: 'var(--mui-palette-text-disabled)',
          },
        },
      },
      {
        props: { color: 'primary' },
        style: {
          '&:not(.Mui-disabled):hover, &:not(.Mui-disabled):active': {
            backgroundColor: 'var(--mui-palette-primary-dark)',
          },
          '&.Mui-disabled': {
            color: 'var(--mui-palette-text-disabled)',
          },
        },
      },
      {
        props: { color: 'secondary' },
        style: {
          '&:not(.Mui-disabled):hover, &:not(.Mui-disabled):active': {
            backgroundColor: 'var(--mui-palette-secondary-lighterOpacity)',
          },
          '&.Mui-disabled': {
            color: 'var(--mui-palette-text-disabled)',
          },
        },
      },
      {
        props: { color: 'error' },
        style: {
          '&:not(.Mui-disabled):hover, &:not(.Mui-disabled):active': {
            backgroundColor: 'var(--mui-palette-error-opacity)',
          },
          '&.Mui-disabled': {
            color: 'var(--mui-palette-text-disabled)',
          },
        },
      },
      {
        props: { color: 'warning' },
        style: {
          '&:not(.Mui-disabled):hover, &:not(.Mui-disabled):active': {
            backgroundColor: 'var(--mui-palette-warning-opacity)',
          },
          '&.Mui-disabled': {
            color: 'var(--mui-palette-text-disabled)',
          },
        },
      },
      {
        props: { color: 'info' },
        style: {
          '&:not(.Mui-disabled):hover, &:not(.Mui-disabled):active': {
            backgroundColor: 'var(--mui-palette-info-opacity)',
          },
          '&.Mui-disabled': {
            color: 'var(--mui-palette-text-disabled)',
          },
        },
      },
      {
        props: { color: 'success' },
        style: {
          '&:not(.Mui-disabled):hover, &:not(.Mui-disabled):active': {
            backgroundColor: 'var(--mui-palette-success-opacity)',
          },
          '&.Mui-disabled': {
            color: 'var(--mui-palette-text-disabled)',
          },
        },
      },
      {
        props: { variant: 'contained' },
        style: {
          backgroundColor: 'var(--mui-palette-primary-main)',
          color: 'var(--mui-palette-primary-contrastText)',
          '&:not(.Mui-disabled):hover, &:not(.Mui-disabled):active': {
            backgroundColor: 'var(--mui-palette-primary-dark)',
            color: 'var(--mui-palette-primary-main)',
          },
          '&.Mui-disabled': {
            backgroundColor: 'var(--mui-palette-background-disabled)',
            color: 'var(--mui-palette-text-disabled)',
          },
        },
      },
    ],
  },
};

export { iconButton };
